import { RESET_STATE } from 'services/auth/constants';

import {
    SET_FINAL_FORM_UNSAVED_VALUES,
    REMOVE_FINAL_FORM_UNSAVED_VALUES
} from './constants';

type State = {};

type Action = {
    +type: string,
    +payload: Object
};

const initialState = {};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_FINAL_FORM_UNSAVED_VALUES:
            return {
                ...state,
                [action.payload.namespace]:
                    action.payload.finalFormUnsavedValues
            };
        case REMOVE_FINAL_FORM_UNSAVED_VALUES: {
            const copy = Object.assign({}, state);
            delete copy[action.payload.namespace];
            return copy;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
